import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useT } from "@/lib/i18n/use-t";
import { CustomFieldDialog } from "./custom-field-dialog";
import { CustomFieldsTable } from "./custom-fields-table";
import { T } from "./custom-fields-wrapper.i18n";
import type { ClientTab, CustomField } from "./settings-types";

type CustomFieldsWrapperProps = {
  initialFields: CustomField[];
  initialTabs?: ClientTab[];
  supportedLanguages?: string[];
};

export function CustomFieldsWrapper({
  initialFields,
  initialTabs = [],
  supportedLanguages = ["en_GB"],
}: CustomFieldsWrapperProps) {
  const t = useT(T);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingField, setEditingField] = useState<CustomField | null>(null);

  const handleCreate = () => {
    setEditingField(null);
    setDialogOpen(true);
  };

  const handleEdit = (field: CustomField) => {
    setEditingField(field);
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setEditingField(null);
  };

  return (
    <>
      <div className="flex items-center justify-between gap-4 mb-4">
        <p className="text-sm text-muted-foreground">{t.description}</p>
        <Button onClick={handleCreate}>{t.addCustomField}</Button>
      </div>

      <CustomFieldsTable fields={initialFields} clientTabs={initialTabs} onEdit={handleEdit} />

      <CustomFieldDialog
        open={dialogOpen}
        field={editingField}
        clientTabs={initialTabs}
        supportedLanguages={supportedLanguages}
        onClose={handleDialogClose}
      />
    </>
  );
}
